import Icon from './Icon';
import { features } from '../constants/content';

export default function Features() {
  return (
    <section className="section section--alt" id="features">
      <div className="container">
        <div className="sec-head sec-head--center">
          <p className="kicker">What You Get</p>
          <h2 className="sec-title">Total Protection. Unlimited Devices.</h2>
          <p className="sec-lead">
            One subscription covers the whole household across Windows, macOS, Android, and iOS —
            with the same level of protection on every device.
          </p>
        </div>

        <div className="feature-grid">
          {features.map((feature) => (
            <article key={feature.title} className="feature-card">
              <span className="feature-card__icon">
                <Icon name={feature.icon} size={24} />
              </span>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
